export default {
  page: 'page',
  fullName: 'full_name_cont',
  query: 'query',
  name: 'query', // TODO: Change actual implementation!
  folderId: 'folder_id_eq',
};
